import { Box } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import Boundary from "models/geospatial/boundary";
import Point from "models/geospatial/point";
import Input from "models/input/input";
import React, { useMemo } from "react";
import RenderField from "components/common/render-field";
import SortInput from "components/common/sort/sort";
import { MetadataPlacement } from "models/input/metadata-placement";
import Template from "models/template";
import MetadataModelTemplates from "./metadata-model-templates/MetadataModelTemplates";
import DatatypeField from "../../../../common/render-field/datatype-field";

export default function Metadata({
  input,
  templates,
  boundaries,
  points,
  placement,
}: Readonly<{
  input: Input;
  templates: Template[];
  boundaries: Boundary[];
  points: Point[];
  placement: MetadataPlacement;
}>) {
  const theme = useEasierTheme();

  const metadata = useMemo(
    () =>
      input.metadata &&
      Object.keys(input.metadata)
        .sort((keyA, keyB) => SortInput(keyA, keyB, input))
        .filter(
          (key) =>
            input.metadata[key] && input.metadata[key]?.placement === placement,
        )
        .map((key) => (
          <RenderField
            key={key}
            label={key}
            field={input.metadata[key]!}
            boundaries={boundaries}
            points={points}
          />
        )),
    [input.input_id, input?.metadata, boundaries, points],
  );

  return (
    <Box display="flex" flexWrap="wrap">
      {placement === "metadata" && (
        <>
          {templates && templates.length > 0 && (
            <MetadataModelTemplates
              input_id={input.input_id}
              templates={templates}
            />
          )}
          <DatatypeField datatype={input.datatype} />
        </>
      )}
      {metadata}
    </Box>
  );
}
